import { render, staticRenderFns } from "./CRUD.vue?vue&type=template&id=58431544&scoped=true&"
import script from "./CRUD.vue?vue&type=script&lang=ts&"
export * from "./CRUD.vue?vue&type=script&lang=ts&"
import style0 from "./CRUD.vue?vue&type=style&index=0&id=58431544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58431544",
  null
  
)

export default component.exports